/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { github_event } from '../models/github_event';
import type { publication_book_army_all } from '../models/publication_book_army_all';
import type { publication_book_army_dto } from '../models/publication_book_army_dto';
import type { publication_book_army_full } from '../models/publication_book_army_full';
import type { publication_book_dto } from '../models/publication_book_dto';
import type { publication_book_full } from '../models/publication_book_full';
import type { publication_book_last_update } from '../models/publication_book_last_update';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PublicationService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get yours army books
   * @returns publication_book_army_full successful
   * @throws ApiError
   */
  public getArmyBooks(): CancelablePromise<Array<publication_book_army_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/publication/book/armies',
    });
  }
  /**
   * Create a new army book
   * @returns publication_book_army_full successful
   * @throws ApiError
   */
  public createArmyBook({
    requestBody,
  }: {
    requestBody?: publication_book_army_dto;
  }): CancelablePromise<publication_book_army_full> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v1/publication/book/armies',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get all yours army books
   * @returns publication_book_army_all successful
   * @throws ApiError
   */
  public getAllArmyBooks(): CancelablePromise<
    Array<publication_book_army_all>
  > {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/publication/book/armies/all',
    });
  }
  /**
   * Get your book
   * @returns publication_book_army_full successful
   * @throws ApiError
   */
  public getBookArmy({
    id,
  }: {
    /**
     * Book identifier
     */
    id: string;
  }): CancelablePromise<publication_book_army_full> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/publication/book/armies/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Update a book
   * @returns publication_book_army_full successful
   * @throws ApiError
   */
  public updateArmyBook({
    id,
    requestBody,
  }: {
    /**
     * Book identifier
     */
    id: string;
    requestBody?: publication_book_dto;
  }): CancelablePromise<publication_book_army_full> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/v1/publication/book/armies/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete a army book
   * @returns void
   * @throws ApiError
   */
  public deleteBook({
    id,
  }: {
    /**
     * Book identifier
     */
    id: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/api/v1/publication/book/armies/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * Get yours books
   * @returns publication_book_full successful
   * @throws ApiError
   */
  public getBooks({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<publication_book_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/publication/books',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create a new book
   * @returns publication_book_full successful
   * @throws ApiError
   */
  public createBook({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: publication_book_dto;
  }): CancelablePromise<publication_book_full> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/publication/books',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get your book
   * @returns publication_book_full successful
   * @throws ApiError
   */
  public getBook({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Book identifier
     */
    id: string;
  }): CancelablePromise<publication_book_full> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/publication/books/{id}',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Update a book
   * @returns publication_book_full successful
   * @throws ApiError
   */
  public updateBook({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Book identifier
     */
    id: string;
    requestBody?: publication_book_dto;
  }): CancelablePromise<publication_book_full> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/publication/books/{id}',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete a book
   * @returns void
   * @throws ApiError
   */
  public deleteBook1({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Book identifier
     */
    id: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/publication/books/{id}',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Build Pdf document
   * @returns publication_book_full successful
   * @throws ApiError
   */
  public buildBook({
    locale,
    id,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Book identifier
     */
    id: string;
  }): CancelablePromise<publication_book_full> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/publication/books/{id}/build',
      path: {
        locale: locale,
        id: id,
      },
    });
  }
  /**
   * Get books with updated_at
   * @returns publication_book_last_update successful
   * @throws ApiError
   */
  public getBookLastUpdate({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<publication_book_last_update>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/publication/books/last_update',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Hook for github event
   * @returns void
   * @throws ApiError
   */
  public hookGithubEvent({
    locale,
    xGitHubEvent,
    xGitHubDelivery,
    xGitHubHookId,
    xGitHubHookInstallationTargetId,
    xGitHubHookInstallationTargetType,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    xGitHubEvent?: string;
    xGitHubDelivery?: string;
    xGitHubHookId?: string;
    xGitHubHookInstallationTargetId?: string;
    xGitHubHookInstallationTargetType?: string;
    requestBody?: github_event;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/publication/github_hooks',
      path: {
        locale: locale,
      },
      headers: {
        'X-GitHub-Event': xGitHubEvent,
        'X-GitHub-Delivery': xGitHubDelivery,
        'X-GitHub-Hook-ID': xGitHubHookId,
        'X-GitHub-Hook-Installation-Target-ID': xGitHubHookInstallationTargetId,
        'X-GitHub-Hook-Installation-Target-Type':
          xGitHubHookInstallationTargetType,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
